import { render } from "./ProdutoUnidades.vue?vue&type=template&id=51a3f39b&ts=true"
import script from "./ProdutoUnidades.vue?vue&type=script&lang=ts"
export * from "./ProdutoUnidades.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__